import { render, staticRenderFns } from "./mydocuments.vue?vue&type=template&id=558aa9ab&scoped=true&"
import script from "./mydocuments.vue?vue&type=script&lang=js&"
export * from "./mydocuments.vue?vue&type=script&lang=js&"
import style0 from "./mydocuments.vue?vue&type=style&index=0&id=558aa9ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558aa9ab",
  null
  
)

export default component.exports